import React from "react";
import "./UsageBox.css";

const UsageBox = ({ title, data }) => {
  return (
    <div className="usage_box_container">
      <div className="usage_box_inner_container">
        <div className="usage_box_title_container">
          <h4
            className="usage_box_title"
            dangerouslySetInnerHTML={{ __html: title }}
          ></h4>
        </div>
        <div
          className="usage_box_content_container"
          dangerouslySetInnerHTML={{ __html: data }}
        ></div>
      </div>
    </div>
  );
};

export default UsageBox;
